function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useDrag, useDrop } from 'react-dnd';

// Set to true to debug this file
const DEBUG = false;
export function DraggableComponent(props) {
  let index = React.useRef(props.index);
  DEBUG && console.log("dragdrop DraggableComponent index ref", index.current, "prop", props.index);
  //index.current = props.index

  const ref = React.useRef(null);
  const [{
    isDragging
  }, drag, dragPreview] = useDrag(() => ({
    type: 'Component',
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    item: () => {
      let rect = (props.theRef || ref).current.getBoundingClientRect();
      return {
        id: props.id,
        index: index,
        height: rect.bottom - rect.top,
        width: rect.right - rect.left,
        rect: rect
      };
    },
    end: (item, monitor) => {
      DEBUG && console.log("dragdrop end", item.index.current, item.id, monitor.didDrop());
      props.onDrop(item.index.current, item.id, monitor.didDrop());
    }
  }));
  React.useEffect(() => {
    var _props$onDrag;
    (_props$onDrag = props.onDrag) === null || _props$onDrag === void 0 ? void 0 : _props$onDrag.call(props, isDragging);
  }, [isDragging]);
  drag(props.theRef || ref);
  return /*#__PURE__*/React.createElement("div", {
    ref: dragPreview,
    style: {
      opacity: isDragging ? 0.5 : undefined
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: props.theRef || ref,
    "data-index": props.index
  }, props), props.children));
}
export function BucketComponent(props) {
  const [{
    isOver,
    handlerId
  }, drop] = useDrop(() => ({
    accept: 'Component',
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      handlerId: monitor.getHandlerId()
    })
  }));
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: drop,
    style: {
      backgroundColor: isOver ? 'grey' : undefined
    },
    "data-handler-id": handlerId
  }, props), props.children);
}
export const Sortable = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _ref;
  let index = React.useRef({});
  index.current = props.index;
  const backupRef = React.useRef(null);
  ref = (_ref = ref) !== null && _ref !== void 0 ? _ref : backupRef;
  const [{
    isOver,
    handlerId
  }, drop] = useDrop(() => ({
    accept: props.type,
    drop: () => ({
      name: index
    }),
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      handlerId: monitor.getHandlerId()
    }),
    hover: (item, monitor) => {
      const hoveredIndex = index.current;
      const draggedIndex = item.index.current;
      if (!monitor.canDrop()) return DEBUG && console.log("dragdrop can't drop");
      if (!(props.theRef || ref).current) return DEBUG && console.log("dragdrop bad ref", props.theRef || ref);
      if (draggedIndex === hoveredIndex) return DEBUG && console.log("dragdrop same index", hoveredIndex);
      if (draggedIndex === undefined) return DEBUG && console.log("dragdrop bad itemIndex", draggedIndex);
      if (hoveredIndex === undefined) return DEBUG && console.log("dragdrop bad hoverIndex", hoveredIndex);
      if (item.id === props.id) return DEBUG && console.log("dragdrop same id", item.id);
      const hoveredBoundingRect = ref.current.getBoundingClientRect();
      const draggedBoundingRect = item.rect;

      //const horizontal = Math.abs(hoveredBoundingRect.left - draggedBoundingRect.left) > Math.abs(hoveredBoundingRect.top - draggedBoundingRect.top)
      // depend on bottom edge
      const horizontal = hoveredBoundingRect.bottom === draggedBoundingRect.bottom;
      const hoveredLength = horizontal ? hoveredBoundingRect.width : hoveredBoundingRect.height;
      const draggedOffset = monitor.getClientOffset();
      const draggedLength = horizontal ? item.rect.width : item.rect.height;
      const mousePos = horizontal ? draggedOffset.x - hoveredBoundingRect.left : draggedOffset.y - hoveredBoundingRect.top;
      if (!draggedLength) return DEBUG && console.log("dragdrop bad length");

      //let deltaLength = Math.max(hoveredLength, draggedLength) - Math.min(hoveredLength, draggedLength)
      const deltaLength = hoveredLength - draggedLength;
      //console.log("dragdrop dl", "draggedLength", draggedLength, "hoveredLength", hoveredLength, "deltaLength", deltaLength, "mousePos", mousePos)

      if (draggedIndex < hoveredIndex && mousePos < deltaLength) return DEBUG && console.log(`dragdrop ret 1: draggedIndex (${draggedIndex}) < hoveredIndex (${hoveredIndex}) && mousePos (${mousePos}) < deltaLength (${deltaLength})`);
      if (draggedIndex > hoveredIndex && mousePos > draggedLength) return DEBUG && console.log(`dragdrop ret 3: draggedIndex (${draggedIndex}) > hoveredIndex (${hoveredIndex}) && mousePos (${mousePos}) > deltaLength (${deltaLength})`);

      //return
      let oldIndex = draggedIndex;
      monitor.getItem().index.current = hoveredIndex;
      DEBUG && console.log("dragdrop onMove", oldIndex, hoveredIndex, draggedLength);
      setTimeout(() => {
        props.onMove(oldIndex, hoveredIndex, draggedLength);
      });
    }
  }));
  const [{
    isDragging
  }, drag] = useDrag(() => ({
    type: props.type,
    item: () => {
      DEBUG && console.log("dragdrop item", props.index, props.id);
      let rect = ref.current.getBoundingClientRect();
      return {
        id: props.id,
        index: index,
        height: rect.bottom - rect.top,
        width: rect.right - rect.left,
        rect: rect
      };
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    }),
    end: (item, monitor) => {
      if (props.onDrop) {
        props.onDrop(item.index.current, monitor.getDropResult(), monitor.didDrop());
      }
      props.onMove(item.index.current, item.index.current);
    }
  }));
  drag(drop(ref));
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    style: {
      backgroundColor: isOver ? 'grey' : undefined,
      opacity: isDragging ? 0 : undefined
    },
    "data-handler-id": handlerId
  }, props), props.children);
});